(function() {
    'use strict';

    angular.module('remitEventsApp').factory('ContractorFilter', function(Contractor, ContractorConfig, $rootScope) {
        var globalContractors = [];
        var globalContractorsConfig = [];

        return {
            getContractors: function() {
                if (_.isEmpty(globalContractors)) {
                    var contractorsForFilter = [];
                    var that = this;

                    this.promiseConfig().then(function(config) {
                        that._promiseContractors().then(function(contractors) {
                            _.each(contractors, function(contractor) {
                                var eic = contractor;
                                var contractorInConfig = that._getContractorFromConfig(config, eic);
                                if (!_.isEmpty(contractorInConfig)) {
                                    var contractorForFilter = {
                                        id: eic,
                                        label: contractorInConfig.name,
                                        selected: false,
                                        shortName: contractorInConfig.shortName
                                    };
                                    contractorsForFilter.push(contractorForFilter);
                                }
                            });
                            globalContractors = contractorsForFilter;
                            $rootScope.$broadcast('contractorsSet', globalContractors);
                        });
                        globalContractorsConfig = config;
                        $rootScope.$broadcast('contractorsConfigSet', globalContractorsConfig);
                    });
                }

                return globalContractors;
            },
            getGlobalContractors: function() {
                if (_.isEmpty(globalContractorsConfig)) {
                    return this.getContractors();
                }

                return globalContractors;
            },
            getContractorsConfig: function() {
                if (_.isEmpty(globalContractorsConfig)) {
                    this.promiseConfig().then(function(config) {
                        globalContractorsConfig = config;
                    });
                }

                return globalContractorsConfig;
            },
            _getContractorFromConfig: function(config, eic) {
                var foundContractor = _.find(config, function(contractor) {
                    return contractor.eicCode === eic;
                });

                return foundContractor;
            },
            _promiseContractors: function() {
                return Contractor.query({}).$promise;
            },
            promiseConfig: function() {
                return ContractorConfig.query({}).$promise;
            },
            filterByShortName: function(contractors, shortName) {
                if (shortName === 'all') {
                    return contractors;
                }
                return _.filter(contractors, function(contractor) {
                    return contractor.shortName === shortName;
                });
            }
        };
    });
})();
